import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseApiUrl } from "../../../services/api";

function InfoInformation({ information }) {
  const [searchTerm, setSearchTerm] = useState("");

  const imageUrl = information && information.image
    ? baseApiUrl.defaults.baseURL + `/image/${information.image}`
    : "default-image.jpg";

  const navigate = useNavigate();

  const truncateText = (text, wordLimit) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
  };

  // Calculate reading time based on content length
  const calculateReadingTime = (text) => {
    if (!text) return 1;
    // Average reading speed: 200 words per minute
    const wordCount = text.split(/\s+/).length;
    const minutes = Math.ceil(wordCount / 200);
    return minutes === 0 ? 1 : minutes; // Minimum 1 minute
  };

  const readingTime = calculateReadingTime(information?.contenu);

  const goToinformationDetail = () => {
    if (information && information.id) {
      navigate(`/information/${information.id}`);
    } else {
      console.error("L'ID de l'information est indéfini !");
    }
  };

  return (
    <div className="col-md-6 col-lg-6 g-6">
      <div className="blog1-single-box" style={{ marginBottom: '30px', height: '100%' }}>
        <div
          className="thumbnail image-anime"
          onClick={goToinformationDetail}
          style={{ cursor: "pointer", height: '100%', display: 'flex', flexDirection: 'column' }}
        >
          <img
            src={imageUrl}
            className="card-img-top"
            alt="informationImage"
            style={{
              width: "100%",
              height: "200px",
              objectFit: "cover",
              borderRadius: "10px",
            }}
          />
          <div className="heading1" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div className="social-area">
              <a href="#" className="time">
                <img
                  src="assets/img/icons/time1.svg"
                  alt="vexon"
                  style={{ width: "16px", height: "16px" }}
                /> {readingTime} min
              </a>
            </div>

            <h4>
              <a style={{ color: "black", fontWeight: "bold" }} href="blog-single.html">
                {truncateText(information ? information.titre : "Aucun", 15)}
              </a>
            </h4>
            <p className="mt-16">{truncateText(information ? information.contenu : "", 30)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoInformation;
